module.exports = __webpack_public_path__ + "img/2_tt.5f84deb9.jpg";